import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
function PolicyModal({
  type,
  onClose
}: {
  type: 'privacy' | 'terms';
  onClose: () => void;
}) {
  const isPrivacy = type === 'privacy';
  return <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.2
  }} data-id="element-108">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-109" />
      <motion.div className="relative bg-navy-900 border border-gold-500/20 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" initial={{
      scale: 0.95,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} exit={{
      scale: 0.95,
      opacity: 0
    }} transition={{
      duration: 0.2
    }} data-id="element-110">
        <div className="sticky top-0 bg-navy-900 border-b border-navy-700 p-5 flex items-center justify-between z-10" data-id="element-111">
          <h2 className="text-xl font-heading font-bold text-white" data-id="element-112">
            {isPrivacy ? 'Política de Privacidad' : 'Términos y Condiciones'}
          </h2>
          <button onClick={onClose} className="text-cream-100/50 hover:text-white transition-colors p-1 rounded-lg hover:bg-navy-800" data-id="element-113">
            <XIcon size={20} data-id="element-114" />
          </button>
        </div>

        <div className="p-6 text-cream-100/80 text-sm leading-relaxed space-y-4" data-id="element-115">
          {isPrivacy ? <>
              <p className="text-cream-100/50 text-xs" data-id="element-116">
                Última actualización: Abril 2026
              </p>

              <h3 className="text-white font-semibold text-base" data-id="element-117">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-118">
                Recopilamos únicamente la información necesaria para procesar su
                compra y entregar el producto digital, incluyendo: nombre,
                dirección de correo electrónico y datos de pago. No almacenamos
                información de tarjetas de crédito directamente; los pagos son
                procesados por proveedores de pago seguros de terceros.
              </p>

              <h3 className="text-white font-semibold text-base" data-id="element-119">
                2. Uso de la Información
              </h3>
              <p data-id="element-120">
                Utilizamos su información personal exclusivamente para: procesar
                y entregar su compra, enviar confirmaciones de pedido,
                proporcionar soporte al cliente relacionado con su compra, y
                cumplir con obligaciones legales.
              </p>

              <h3 className="text-white font-semibold text-base" data-id="element-121">
                3. Protección de Datos
              </h3>
              <p data-id="element-122">
                Implementamos medidas de seguridad técnicas y organizativas para
                proteger su información personal contra acceso no autorizado,
                alteración, divulgación o destrucción. Toda la transmisión de
                datos se realiza mediante conexiones cifradas (SSL/TLS).
              </p>

              <h3 className="text-white font-semibold text-base" data-id="element-123">
                4. Compartir Información
              </h3>
              <p data-id="element-124">
                No vendemos, intercambiamos ni transferimos su información
                personal a terceros, excepto a proveedores de servicios de
                confianza que nos asisten en la operación de nuestro sitio web y
                el procesamiento de pagos, siempre que dichas partes acuerden
                mantener esta información confidencial.
              </p>

              <h3 className="text-white font-semibold text-base" data-id="element-125">
                5. Sus Derechos
              </h3>
              <p data-id="element-126">
                Usted tiene derecho a acceder, rectificar o eliminar su
                información personal en cualquier momento. También puede
                solicitar la portabilidad de sus datos o retirar su
                consentimiento para el procesamiento de datos.
              </p>

              <h3 className="text-white font-semibold text-base" data-id="element-127">6. Cookies</h3>
              <p data-id="element-128">
                Utilizamos cookies esenciales para el funcionamiento del sitio y
                cookies analíticas para mejorar la experiencia del usuario.
                Puede configurar su navegador para rechazar cookies, aunque esto
                puede afectar la funcionalidad del sitio.
              </p>
            </> : <>
              <p className="text-cream-100/50 text-xs" data-id="element-129">
                Última actualización: Abril 2026
              </p>

              <h3 className="text-white font-semibold text-base" data-id="element-130">
                1. Aceptación de los Términos
              </h3>
              <p data-id="element-131">
                Al acceder y utilizar este sitio web y adquirir el producto
                "Protocolo Próstata: Noches en Paz", usted acepta estar sujeto a
                estos Términos y Condiciones. Si no está de acuerdo con alguna
                parte de estos términos, no debe utilizar nuestro sitio ni
                adquirir nuestros productos.
              </p>

              <h3 className="text-white font-semibold text-base" data-id="element-132">
                2. Naturaleza del Producto
              </h3>
              <p data-id="element-133">
                "Protocolo Próstata: Noches en Paz" es un producto digital de
                carácter educativo e informativo. No constituye consejo médico,
                diagnóstico ni tratamiento. Los resultados pueden variar de
                persona a persona. Siempre consulte con un profesional de salud
                calificado antes de realizar cambios en su rutina de salud.
              </p>

              <h3 className="text-white font-semibold text-base" data-id="element-134">
                3. Entrega del Producto
              </h3>
              <p data-id="element-135">
                El producto se entrega en formato digital (PDF) inmediatamente
                después de completar la compra. Recibirá acceso instantáneo a
                través del enlace de descarga proporcionado tras el pago.
              </p>

              <h3 className="text-white font-semibold text-base" data-id="element-136">
                4. Política de Reembolso
              </h3>
              <p data-id="element-137">
                Ofrecemos una garantía de satisfacción. Si no está satisfecho
                con el producto, puede solicitar un reembolso dentro del período
                establecido contactándonos directamente. Los reembolsos se
                procesarán a través del mismo método de pago utilizado para la
                compra.
              </p>

              <h3 className="text-white font-semibold text-base" data-id="element-138">
                5. Propiedad Intelectual
              </h3>
              <p data-id="element-139">
                Todo el contenido del producto, incluyendo textos, gráficos y
                diseño, está protegido por derechos de autor. La compra otorga
                una licencia personal e intransferible. Queda prohibida la
                reproducción, distribución o reventa del contenido sin
                autorización expresa.
              </p>

              <h3 className="text-white font-semibold text-base" data-id="element-140">
                6. Limitación de Responsabilidad
              </h3>
              <p data-id="element-141">
                En ningún caso seremos responsables por daños directos,
                indirectos, incidentales o consecuentes que resulten del uso o
                la imposibilidad de uso del producto. El uso del producto es
                bajo su propia responsabilidad.
              </p>

              <h3 className="text-white font-semibold text-base" data-id="element-142">
                7. Modificaciones
              </h3>
              <p data-id="element-143">
                Nos reservamos el derecho de modificar estos Términos y
                Condiciones en cualquier momento. Las modificaciones entrarán en
                vigor inmediatamente después de su publicación en el sitio web.
              </p>
            </>}
        </div>
      </motion.div>
    </motion.div>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-950 py-10 text-center text-cream-100/40 text-sm" data-id="element-144">
        <div className="container mx-auto px-4 max-w-[720px]" data-id="element-145">
          <p className="mb-4 leading-relaxed" data-id="element-146">
            Descargo de responsabilidad: La información proporcionada en este
            sitio web y en el producto "Protocolo Próstata: Noches en Paz" tiene
            fines puramente educativos e informativos. No pretende sustituir el
            consejo, diagnóstico o tratamiento médico profesional. Siempre
            busque el consejo de su médico u otro proveedor de salud calificado
            con cualquier pregunta que pueda tener sobre una condición médica.
          </p>

          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-147">
            <button onClick={() => setActiveModal('privacy')} className="text-cream-100/50 hover:text-gold-400 transition-colors underline underline-offset-2" data-id="element-148">
              Política de Privacidad
            </button>
            <span className="text-cream-100/20" data-id="element-149">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-cream-100/50 hover:text-gold-400 transition-colors underline underline-offset-2" data-id="element-150">
              Términos y Condiciones
            </button>
          </div>

          <p data-id="element-151">
            &copy; {new Date().getFullYear()} Protocolo Próstata. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-152">
        {activeModal && <PolicyModal type={activeModal} onClose={() => setActiveModal(null)} data-id="element-153" />}
      </AnimatePresence>
    </>;
}